module.exports = __webpack_public_path__ + "media/packs/images/flags/US-8e0fe936d4a53c30a82a0c96da5cca0d.svg";